export const environment = {
  region: '__REGION__',
  userPoolId: '__USER_POOL_ID__',
  webClientId: '__WEB_CLIENT_ID__',
  domain: '__DOMAIN__',
  scope: '__SCOPE__',
  redirectSignIn: '__REDIRECT_SIGN_IN__',
  redirectSignOut: '__REDIRECT_SIGN_IN__',
  responseType: '__RESPONSE_TYPE__',
  apiUrl: '__API_URL__',
  xOrigin: '__X_ORIGIN__',
  xUserOrigin: '__X_USER_ORIGIN__',
  staticsUrl: '__STATICS_URL__',
};
